import { useTranslation } from "react-i18next";
import { SettingsLayout } from "@/components/settings/SettingsLayout";
import { SettingsCard } from "@/components/settings/SettingsCard";
import { ThemeSelect } from "./ThemeSelect";
import { LanguageSelect } from "./LanguageSelect";
import { AlertSubscriptionsCard } from "./AlertSubscriptionsCard";
import { NotificationChannelsCard } from "./NotificationChannelsCard";
import { useCurrentUser } from "@/shell/useCurrentUser";

export function PreferencesPage() {
  const { t } = useTranslation("preferences");
  const me = useCurrentUser();
  return (
    <SettingsLayout title={t("page.title")} description={t("page.description")}>
      <SettingsCard title={t("appearance.title")} description={t("appearance.description")}>
        <ThemeSelect />
      </SettingsCard>
      <SettingsCard title={t("language.title")} description={t("language.description")}>
        <LanguageSelect />
      </SettingsCard>
      <SettingsCard title={t("alerts.title")} description={t("alerts.description")}>
        <AlertSubscriptionsCard email={me.data?.email ?? null} />
      </SettingsCard>
      <SettingsCard title={t("channels.title")} description={t("channels.description")}>
        <NotificationChannelsCard email={me.data?.email ?? null} />
      </SettingsCard>
    </SettingsLayout>
  );
}
